import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { verify_admin } from "../store/actions";

const AppRoute = ({ children, requiredPermission }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const permission = useSelector((state) => state.Login.permissionArry);
	const sessionExpired = useSelector((state) => state.Login.sessionExpired);

	useEffect(() => {
		dispatch(verify_admin());
		setToken(localStorage.getItem("token"))

	}, [dispatch, location.pathname]);


	const [token, setToken] = React.useState(localStorage.getItem("token"))
	const verify = useSelector((state) => state.Login.verifyAdmin);
	const permissionsLoaded = Boolean(verify && verify.user && verify.user.data);

	if (sessionExpired || (verify && verify.data)) {
		return <Navigate to="/login" state={{ from: location }} replace />
	}
	if (!token) {
		return (
			<Navigate to="/login" state={{ from: location }} replace />
		);

	}
	if (requiredPermission && !permissionsLoaded) {
		return null;
	}
	if (permissionsLoaded && requiredPermission && !(permission || []).includes(requiredPermission)) {
		return <Navigate to="/not-authorized" />;
	}
	return (<React.Fragment>
		{children}
	</React.Fragment>);
}

export default AppRoute;

